import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import React, { useContext } from 'react';

import { ArrowUp } from '../Icon';
import * as styles from './ScrollToTop.module.css';

const ScrollToTop = () => {
	const { variant } = useContext(ThemeContext);
	return (
		<a
			href="#top"
			className={cx(styles.button, styles[variant])}
			aria-label="Scroll to top"
		>
			<div className={cx(styles.icon, styles[variant])}>
				<ArrowUp />
			</div>
		</a>
	);
};

export default ScrollToTop;
